import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Errore imprevisto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function eur(v) {
  if (v == null) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", useGrouping: "always" }).format(v);
}


// Avviso premio minimo Agenzia (impostato dall'Admin per prodotto).
export function minimoMsg(r) {
  if (r?.minimo_agenzia_applicato) return [`Applicato il premio minimo Agenzia di ${eur(r.premio_minimo_agenzia)} (calcolato ${eur(r.premio_finale_calcolato)}).`];
  if (r?.minimo_agenzia_derogato) return [`Premio sotto il minimo Agenzia di ${eur(r.premio_minimo_agenzia)}: il tuo profilo può scendere sotto senza autorizzazione.`];
  return [];
}
